// extracted by mini-css-extract-plugin
export default {"root":"qRYQfy","blockInfo":"MvOQyg","imgBlock":"qGuaOi","icon":"Ler30e","positive":"p3qUO6","negative":"kC08iT","img":"KcHrFy","title":"OenvMI","averageRating":"ALyvGS"};